import { useDispatch } from "react-redux";
import {
    updateCustomModal,
    updateCustomModalTitle,
    updateKeywordModalType,
    updateKeywords,
} from "@features/modalSlice";
import { titleCase } from "@ts/utils";
import { ICellRendererParams } from "ag-grid-community";

interface IKeywordCellRenderer extends ICellRendererParams {
    hasPinnedColumnValue: boolean;
    pinnedColumnValue: string;
    isKeywordLinkRequired: boolean;
}

const KeywordCellRenderer: React.FC<IKeywordCellRenderer> = (params) => {
    const data = params.data.keyword_type_map;
    const dispatch = useDispatch();
    const modalClickHandler = () => {
        dispatch(updateCustomModal(true));
        dispatch(updateCustomModalTitle(params.value));
        dispatch(updateKeywordModalType("keywords-modal"));
        dispatch(updateKeywords(data.split(",").map((item: string) => +item)));
    };

    return (
        <>
            {params.node.rowPinned ? (
                params.pinnedColumnValue
            ) : (
                <span className={params.isKeywordLinkRequired ? "anchor-class" : ""} onClick={params.isKeywordLinkRequired && modalClickHandler}>
                        {(params.value) || ""}
                </span>
            )}
        </>
    );
};

export default KeywordCellRenderer;
